export default {
  labels: {
    open: 'Pokaż pozycje',
    collapse: 'Zwiń pozycje',
    in_stock: 'Dostępny',
    out_of_stock: 'Niedostępny',
  },
  list: {
    name: 'Pozycja menu',
    price: 'Cena',
    is_available: 'DOSTĘPNY/NIEDOSTĘPNY',
  },
};
